// TODO: Should these style constants be in the theme or somewhere else?
// See this MR discussion - https://gitlab.com/auviknetworks/saaslio/frontend/-/merge_requests/742#note_2359322936

export const PAGE_HEADER_HEIGHT = '60px';

export const APP_LIST_WIDTH = '320px';

// Form footer height (72px) + 16px padding
export const FORM_BOTTOM_MARGIN = '88px';

// 48px = spacing={3} on the Grid - 24px top and bottom.
export const CALCULATED_GRID_HEIGHT = `calc(100vh - ${PAGE_HEADER_HEIGHT} - 48px)`;
// 48px = spacing={3} on the Grid - 24px top and bottom
// 72px = height of form footer
export const CALCULATED_GRID_HEIGHT_WITH_FORM_SUBMIT = `calc(100vh - ${PAGE_HEADER_HEIGHT} - 48px - 72px)`;
